(function() {
  'use strict';
  angular.module('benefits')
  .component('procedureLookup', {
    bindings: {
      refId: '=',
      modalOpen: '=',
      uniqueId:'=',
      eligibilityAuditts:'='
    },
    controller: ['benefitService', '$uibModal', '$http', '$filter','secSecurityService',function procedureLookupController(benefitService, $uibModal, $http, $filter,securityService) {
      var ctrl = this;
      ctrl.procedureCode = "";
      ctrl.submit = submit;
      ctrl.errorCode = false;
      ctrl.errorString = "";
      ctrl.$onInit = function() {
        benefitService.checkPolicyForBenefitBlock(ctrl.refId).then(function(data){
          ctrl.isBenefitBlock = data;
        });
      };
      function submit() {
        var formattedCode = '';
        if(ctrl.procedureCode.charAt(0) == ('d') || ctrl.procedureCode.charAt(0) == ('D')) {
          formattedCode = _.trim(ctrl.procedureCode, 'dD');
        } else {
          formattedCode = ctrl.procedureCode;
        }
        while(formattedCode.length < 4) {
          formattedCode = "0" + formattedCode;
        }
  	  	if(ctrl.eligibilityAuditts != null && ctrl.eligibilityAuditts!== undefined){
  	      ctrl.historyFlow = true;
  	  	} else{
  	  	  ctrl.historyFlow = false;
  	  	}
        ctrl.procedureValid = true;
        benefitService.checkProcedureBlock(formattedCode, ctrl.refId).then(function(data){
          ctrl.procedureValid = data;
          ctrl.errorCode = false;
          if(_.parseInt(formattedCode) < 100) {
        	  displayInitialErrorCode(formattedCode,'Please enter a valid procedure code');
          } else if(!ctrl.procedureValid) {
        	  displayInitialErrorCode(formattedCode,'You are not eligible to look up this procedure. Please Contact Support for more information.');
          } else {
        	  if(ctrl.historyFlow){
        		  historyFlow(formattedCode)
        	  } else{
        		  normalFlow(formattedCode)
        	  }
          }
        });
      }
      function saveErrorCodeHistory(formattedCode,errorString){
    	  if(!ctrl.historyFlow){
    		  securityService.getUserHome().then(function (userHome) {
        	        if(userHome == 'lookup'){
        	  		  let errorMap = new Map()
            		  errorMap['errorString'] = errorString;
           			  //console.log(errorMap)
            		  $http.post('members/' + ctrl.uniqueId +'/'+ formattedCode+ '/saveProcedureCodeLookup',errorMap);
        	    	}
        	      });
    	  }
      }
      function displayInitialErrorCode(formattedCode,errStr){
    	  ctrl.foundInHistory=false;
    	  if(ctrl.historyFlow) {
    	   ctrl.running = true;
    	   $http.get('members/' + ctrl.uniqueId +'/'+formattedCode+ '/getProcedureCodeHistory').then(function(categoryInfo) {
    		  ctrl.running = false;
    		  if(categoryInfo.data != null & categoryInfo.data != '' && categoryInfo.data.data.errorString!=undefined && categoryInfo.data.data.errorString!=null && categoryInfo.data.data.errorString!= '') {
   				  ctrl.errorCode = true;
   		          ctrl.errorString = "As of "+getTimestamp(categoryInfo.data.updatedTS)+" this is the information available."+categoryInfo.data.data.errorString;
   		          ctrl.foundInHistory=true;
    		  }
    		});
    	  }

    	  if(!ctrl.foundInHistory) {
	          ctrl.errorCode = true;
	          ctrl.errorString = errStr;
	          if(!ctrl.historyFlow) {
	        	  saveErrorCodeHistory(formattedCode,ctrl.errorString);
	          }
		  }
      }

      function historyFlow(formattedCode){
    	  ctrl.running = true;
    	  $http.get('members/' + ctrl.uniqueId +'/'+formattedCode+ '/getProcedureCodeHistory').then(function(categoryInfo) {
    		  ctrl.running = false;
      		  ctrl.showHistoryMessage = true;
    		  if(categoryInfo.data != null & categoryInfo.data != ''){
    			  if(categoryInfo.data.data.errorString!=undefined && categoryInfo.data.data.errorString!=null && categoryInfo.data.data.errorString!= ''){
    				  ctrl.errorCode = true;
    		          ctrl.errorString = "As of "+getTimestamp(categoryInfo.data.updatedTS)+" this is the information available."+categoryInfo.data.data.errorString;
    			  }else{
    				  ctrl.procedureCodeAuditUTS = categoryInfo.data.updatedTS;
    				  showProcedureLookupModel(categoryInfo.data);
    			  }
    		  }else{
    			  normalFlow(formattedCode)
    		  }
    	  });
      }
      function normalFlow(formattedCode){
          ctrl.running = true;
    	  ctrl.showHistoryMessage = false;
          $http.get('members/' + ctrl.refId + '/procedureBenefits/' + formattedCode).then(function(categoryInfo) {
            ctrl.running = false;
            if (categoryInfo && categoryInfo.data && categoryInfo.data.benefit) {
              showProcedureLookupModel(categoryInfo);
              	if(!ctrl.historyFlow){
              	   securityService.getUserHome().then(function (userHome) {
              	        if(userHome == 'lookup'){
                      		$http.post('members/' + ctrl.uniqueId +'/'+ formattedCode+ '/saveProcedureCodeLookup',categoryInfo.data);
              	    	}
              	      });
            	}
              } else {
              //Not found - display the code is not valid
              ctrl.errorCode = true;
              if(categoryInfo.data.procedureStatus == "inactive"){
                ctrl.errorString = 'This procedure code is no longer active';
              } else if(categoryInfo.data.procedureStatus == 'invalid') {
                ctrl.errorString = 'Please enter a valid procedure code';
              } else {
                  ctrl.errorString = 'An error occurred while trying to retrieve this procedure code please try again.';
              }
              if(!ctrl.historyFlow){
            	  saveErrorCodeHistory(formattedCode,ctrl.errorString);
              }
            }
          }, function(error){
            ctrl.running = false;
          });
      }
      function showProcedureLookupModel(categoryInfo){
          ctrl.modalOpen = true;
          ctrl.procedureCode = '';
          var modalInstance = $uibModal.open({
              templateUrl: 'js/benefits/procedureCodeLookupModal.html' + appVersion,
              controllerAs:'vm',
              controller: 'procedureModalController',
              size: 'lg',
              animation: false,
              resolve:{
                categoryInfo: function() {
                  return categoryInfo.data;
                },
                procedureCodeAuditUTS: function() { return ctrl.procedureCodeAuditUTS; },
                showHistoryMessage: function() { return ctrl.showHistoryMessage; }
              }
            });
            modalInstance.result.then(function(data) {
              ctrl.modalOpen = false;
            }, function() {
              ctrl.modalOpen = false;
            });

      }
      function getTimestamp(date) {
          let d = new Date(date).getTime();
          let tzOffset = new Date().getTimezoneOffset() * 60 * 1000;
          return $filter('date')(d - tzOffset, 'M/d/yy h:mm a');
      }
     }],
    templateUrl: 'js/benefits/procedureCodeLookup.html' + appVersion
  });
})();
